module.exports = __webpack_public_path__ + "b770a0038529684cbd42d976c6ec0271.ttf";